module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-04-99c69a09fd6742ef5802269ef73f190f.jpg";